import { FunctionComponent } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Text, Stack } from '@atlaskit/primitives';
import { useInfo, useToken } from '../../../Flow/ConsentContextProvider';

const messages = defineMessages({
  aboutHeader: {
    id: 'oauth.bitbucket.description.about',
    defaultMessage: 'About {clientName}',
    description: 'Header for the OAuth Consumer description section',
  },
});

const Description: FunctionComponent = () => {
  const { clientName } = useToken();
  const { client } = useInfo();
  const { appDescription } = client ?? {};

  if (!appDescription) {
    return null;
  }

  return (
    <Stack space={'space.200'}>
        <Text weight="bold">
          <FormattedMessage
            {...messages.aboutHeader}
            values={{
              clientName
            }}
          />
        </Text>
      <Text color="color.text.subtle">{appDescription}</Text>
    </Stack>
  );
};

export default Description;
